<template>
  <div class="element-input element-select" :class="{ empty: !value }">
    <div class="label" @click="clickHelp">
      <p>
        <span :class="{ active: dropbox && statusHelp }">{{ label }}</span>
        <img v-if="dropbox" :src="statusHelp ? '../static/cancel_blue.png' : '../static/help_gray.png'" />
      </p>
      <div class="dropbox" v-if="dropbox && statusHelp">
        {{ dropbox }}
      </div>
    </div>
    
    <div class="body" :style="{ 'border': valid ? '1px solid #e6e6e6' : '1px solid #cc3232' }">
      <div>{{ (value && items.length) ? (items.filter( o => o.value == value )[0] || { label: '', value: '' }).label : placeholder }}</div>
      <i class="material-icons">expand_more</i>
      <!--<select v-model="model" :disabled="disabled">
        <option v-if="placeholder" value="">{{ placeholder }}</option>
        <option v-for="opt in items" :value="opt.value">{{ opt.label }}</option>
      </select>-->
      <element-combo-box v-model="model" :items="items" />
    </div>
    
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "items", "disabled", "placeholder", "dropbox", 'validate' ],
  data(){
    return {
      statusHelp: false,
      show: false,
    }
  },
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    },
    valid() {
      if (this.validate) {
        return this.value === '' ? false: true;
      }

      return true;
    }
  },
  methods: {
    clickHelp(){
      this.statusHelp = !this.statusHelp
    },
    selectItem( value ){
      this.$emit( "input", value );
    }
  }
}
</script>
